/**
 * How a tool call names itself, in both the stream and the stored row.
 *
 * A tool the model was given up front is stored as `tool-<name>`, so the name is part of the type.
 * A tool resolved at run time has no type of its own and arrives as `dynamic-tool` with the name
 * in a field. Both shapes are read in one place so nothing else has to know the split.
 */

/** Prefix in front of the tool name in the part type of a statically named tool. */
export const TOOL_TYPE_PREFIX = 'tool-';

/** Part type of a tool resolved at run time, which carries its name in `toolName`. */
export const DYNAMIC_TOOL_TYPE = 'dynamic-tool';
